export default __webpack_public_path__ + "static/media/tips-active.b72f0370.svg";